/* eslint-disable consistent-return */
import {
    DialogProgrammatic as Dialog,
    ToastProgrammatic as Toast,
    LoadingProgrammatic as Loading,
    ModalProgrammatic as Modal,
} from 'buefy';
import DialogReportPay from '@/components/DialogReportPay.vue';
import DialogTollRoadStatus from '@/components/DialogTollRoadStatus.vue';
import DialogReportPaid from '@/components/DialogReportPaid.vue';
import DialogConfirmVerifiedPayment from '@/components/DialogConfirmVerifiedPayment.vue';
import DialogUpdateNote from '@/components/DialogUpdateNote.vue';
import DialogUpdateTask from '@/components/DialogUpdateTask.vue';
import DialogReportDriverAssign from '@/components/DialogReportDriverAssign.vue';
import DialogAddTask from '@/components/DialogAddTask.vue';
import DialogChangeTransferStatusCompany from '@/components/DialogChangeTransferStatusCompany.vue';
import DialogChangeTransferStatusCompanyAdmin from '@/components/DialogChangeTransferStatusCompanyAdmin.vue';
import DialogChangeTransferStatusCompanyAdminLimited from '@/components/DialogChangeTransferStatusCompanyAdminLimited.vue';
import DialogChangeTransferStatusDriverAdmin from '@/components/DialogChangeTransferStatusDriverAdmin.vue';
import DialogChangeTransferStatusDriver from '@/components/DialogChangeTransferStatusDriver.vue';
import ReportStatusManageWidget from '@/components/Widgets/ReportStatusManageWidget.vue';
import DialogSign from '@/components/DialogSign.vue';
import { saveAs } from 'file-saver';
import LeasingCompaniesService from '@/services/LeasingCompaniesService';
import printer from '../plugins/printer';
import ReportService from './ReportService';
import AccidentService from './AccidentService';
import DriverService from './DriverService';
import VehicleService from './VehicleService';
import store from '../store';

const actions = {
    approvePay: {
        Id: 'ApprovePay',
        Label: 'אישור דוחות לתשלום',
        icon: 'checkbox-multiple-blank-circle',
        click: (reports, onSuccess) => {
            Dialog.confirm({
                message: 'האם ברצונך לאשר את דוחות אלה לתשלום?',
                confirmText: 'כן',
                cancelText: 'לא',
            })
                .then(({ result }) => {
                    if (result) {
                        const loading = Loading.open({
                            isFullPage: true,
                        });
                        ReportService
                            .approvePayment(reports.map((r) => r.Id))
                            .then(() => {
                                if (onSuccess) onSuccess();
                                Toast.open({
                                    type: 'is-success',
                                    message: 'הדוחות אושרו לתשלום!',
                                    duration: 4000
                                });
                            })
                            .catch(() => {
                                Toast.open({
                                    type: 'is-danger',
                                    message: 'לא היה ניתן לבצע את הפעולה, נסה לאשר דוחות שוב.',
                                    duration: 8000
                                });
                            })
                            .finally(() => {
                                loading.close();
                            });
                    }
                });
        },
    },
    updateReportsFromRePort: {
        Id: 'updateReportsFromRePort',
        Label: 'משיכת מסמכי הסבה ממערכת הליסינג',
        icon: 'pencil',
        click: (reports, onSuccess) => {
            Dialog.confirm({
                message: 'האם ברצונך לבצע משיכת מסמכי הסבה לדוחות אלו?',
                confirmText: 'כן',
                cancelText: 'לא',
            })
                .then(({ result }) => {
                    if (result) {
                        const loading = Loading.open({
                            isFullPage: true,
                        });
                        ReportService
                            .pullTransfersFromReport(reports.map((r) => r.Id))
                            .then((r) => {
                                r.data.map((i, idx) => i.ReportId = reports[idx].ReportNumber);
                                const successedReports = r.data.filter((i) => i.Success);
                                const failedReports = r.data.filter((i) => !i.Success);
                                Dialog.confirm({
                                    message: `
                                <div style="max-height:300px">
                                <div style="font-weight: bold">מידע ל <span style="font-weight: bold">${r.data.length}</span> דוחות.</div>
                                ${successedReports && successedReports.length ? `<div>
                                    התקבלו פרטי עובד ומסמכים ממערכת הפנימית של הלקוח. מועבר לבדיקה לצורך הפקת הסבה. (${successedReports.length}):
                                    ${successedReports.map((rep) => `<div>מספר דוח: ${rep.ReportId}.</div>`).join('')}
                                    </div>`
                                            : ''
                                        }
                                ${failedReports && failedReports.length ? `<div>
                                    דוחות שנכשלו (${failedReports.length}):
                                    ${failedReports.map((rep) => `<div>מספר דוח: ${rep.ReportId}. שגיאה: ${rep.Message}.</div>`).join('')}
                                    </div>`
                                            : ''
                                        }
                                </div>`,
                                    onConfirm: () => onSuccess(),
                                    confirmText: 'שמור',
                                    canCancel: false
                                });
                            })
                            .catch(() => {
                                Toast.open({
                                    type: 'is-danger',
                                    message: 'לא היה ניתן לבצע את הפעולה, נסה לבצע משיכת מסמכי הסבה שוב.',
                                    duration: 8000,
                                });
                            })
                            .finally(() => {
                                loading.close();
                            });
                    }
                });
        },
    },
    disApprovePay: {
        Id: 'DisApprovePay',
        Label: 'ביטול אישור דוחות לתשלום',
        icon: 'checkbox-multiple-blank-circle-outline',
        click: (reports, onSuccess) => {
            Dialog.confirm({
                message: 'האם ברצונך לבטל את דוחות אלה מאישור לתשלום?',
                confirmText: 'כן',
                cancelText: 'לא',
            })
                .then(({ result }) => {
                    if (result) {
                        const loading = Loading.open({
                            isFullPage: true,
                        });
                        ReportService
                            .disapprovePayment(reports.map((r) => r.Id))
                            .then(() => {
                                if (onSuccess) onSuccess();
                                Toast.open({
                                    type: 'is-success',
                                    message: 'הדוחות בוטלו מאישור לתשלום!',
                                    duration: 4000,
                                });
                            })
                            .catch(() => {
                                Toast.open({
                                    type: 'is-danger',
                                    message: 'לא היה ניתן לבצע את הפעולה, נסה לאשר דוחות שוב.',
                                    duration: 8000,
                                });
                            })
                            .finally(() => {
                                loading.close();
                            });
                    }
                });
        },
    },
    payReports: {
        Id: 'PayReports',
        Label: 'תשלום דוחות',
        icon: 'credit-card-check',
        click: () => {
            Modal.open({
                component: DialogReportPay,
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    verifiedPayment: {
        Id: 'VerifiedPayment',
        Label: 'וידאתי תשלום',
        icon: 'check-decagram',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogConfirmVerifiedPayment,
                props: {
                    reports: reports.map((r) => r.Id),
                    reportNumbers: reports.map((r) => r.ReportNumber),
                    onSuccess,
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    markAsPaid: {
        Id: 'MarkAsPaid',
        Label: 'סימון דוחות כשולמו',
        icon: 'cash-check',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogReportPaid,
                props: {
                    reports: reports.map((r) => r.Id),
                    onSuccess,
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    updateNote: {
        Id: 'UpdateNote',
        Label: 'עדכון הערה',
        icon: 'pencil',
        click: (tasks, onSuccess) => {
            Modal.open({
                component: DialogUpdateNote,
                props: {
                    tasks: tasks.map((t) => t),
                    onSuccess,
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    updateTask: {
        Id: 'UpdateTask',
        Label: 'עדכון משימה',
        icon: 'pencil',
        click: (tasks, onSuccess) => {
            Modal.open({
                component: DialogUpdateTask,
                props: {
                    tasks: tasks.map((t) => t),
                    onSuccess,
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    addTask: {
        Id: 'AddTask',
        Label: 'הוספת משימה/הערה',
        icon: 'plus',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogAddTask,
                props: {
                    reports: reports.map((t) => t),
                    onSuccess,
                    store
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    driverAssign: {
        Id: 'DriverAssign',
        Label: 'שיוך לעובד',
        icon: 'account-switch-outline',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogReportDriverAssign,
                props: {
                    reports: reports.map((r) => r.Id),
                    currentDriver: reports.length && reports[0].Driver ? {
                        driverId: reports[0].Driver.Id,
                        isDriverPaid: reports[0].IsPaidByDriver,
                        showAmount: !!reports[0].DriverAmount,
                        amount: reports[0].DriverAmount
                    } : undefined,
                    onSuccess,
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    changeTransferStatusCompany: {
        Id: 'ChangeTransferStatusCompany',
        Label: 'שינוי סטטוס הסבה',
        icon: 'account-arrow-right-outline',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogChangeTransferStatusCompany,
                props: {
                    reportsNumber: reports.map((r) => r.ReportNumber),
                    reports: reports.map((r) => r.Id),
                    onSuccess,
                    onlyManualChange: false
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    changeManualTransferStatusCompany: {
        Id: 'ChangeManualTransferStatusCompany',
        Label: 'שינוי סטטוס הסבה',
        icon: 'account-arrow-right-outline',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogChangeTransferStatusCompany,
                props: {
                    reportsNumber: reports.map((r) => r.ReportNumber),
                    reports: reports.map((r) => r.Id),
                    onSuccess,
                    onlyManualChange: true
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    changeTransferStatusCompanyLimited3: {
        Id: 'ChangeTransferStatusCompanyLimited3',
        Label: 'שינוי סטטוס הסבת לקוח',
        icon: 'account-arrow-right-outline',
        click: (reports, onSuccess) => {
            // Build allowed status names based on profile settings
            const allowedStatusNames = [
                'ההסבה הושלמה',
                'נשלח בדואר רשום'
            ];
            // Add "הסבה ידנית ע"י לקוח" if allowed in profile settings
            if (store.state.profile?.AllowManualChangeMenu) {
                allowedStatusNames.push('הסבה ידנית ע"י לקוח');
            }
            Modal.open({
                component: DialogChangeTransferStatusCompany,
                props: {
                    reportsNumber: reports.map((r) => r.ReportNumber),
                    reports: reports.map((r) => r.Id),
                    onSuccess,
                    onlyManualChange: false,
                    allowedStatusNames
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    changeTransferStatusCompanyAdmin: {
        Id: 'changeTransferStatusCompanyAdmin',
        Label: 'שינוי סטטוס הסבה',
        icon: 'account-arrow-right-outline',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogChangeTransferStatusCompanyAdmin,
                props: {
                    reportsNumber: reports.map((r) => r.ReportNumber),
                    // reports: reports.map((r) => r.Id),
                    transferIds: reports.map((r) => r.TransferBatchItemId),
                    onSuccess,
                    store
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    changeTransferStatusCompanyAdminLimited: {
        Id: 'changeTransferStatusCompanyAdminLimited',
        Label: 'שינוי סטטוס הסבה',
        icon: 'account-arrow-right-outline',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogChangeTransferStatusCompanyAdminLimited,
                props: {
                    reportsNumber: reports.map((r) => r.ReportNumber),
                    // reports: reports.map((r) => r.Id),
                    transferIds: reports.map((r) => r.TransferBatchItemId),
                    onSuccess,
                    store
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    changeTransferStatusDriverAdmin: {
        Id: 'changeTransferStatusDriverAdmin',
        Label: 'שינוי סטטוס הסבה עובד',
        icon: 'account-arrow-left-outline',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogChangeTransferStatusDriverAdmin,
                props: {
                    reportsNumber: reports.map((r) => r.ReportNumber),
                    reports: reports.map((r) => r.Id),
                    onSuccess,
                    store
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    changeTransferStatusDriver: {
        Id: 'ChangeTransferStatusDriver',
        Label: 'שינוי סטטוס הסבה עובד',
        icon: 'account-arrow-left-outline',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogChangeTransferStatusDriver,
                props: {
                    reportsNumber: reports.map((r) => r.ReportNumber),
                    reports: reports.map((r) => r.Id),
                    onSuccess,
                    store,
                    onlyManualChange: false
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    changeManualTransferStatusDriver: {
        Id: 'ChangeTransferStatusDriver',
        Label: 'שינוי סטטוס הסבה עובד',
        icon: 'account-arrow-left-outline',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogChangeTransferStatusDriver,
                props: {
                    reportsNumber: reports.map((r) => r.ReportNumber),
                    reports: reports.map((r) => r.Id),
                    onSuccess,
                    store,
                    onlyManualChange: true
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    changeReportStatus: {
        Id: 'ChangeReportStatus',
        Label: 'ניהול סטטוס דוח',
        icon: 'flag-variant-outline',
        click: (reports, onSuccess) => {
            Modal.open({
                component: ReportStatusManageWidget,
                props: {
                    reports: reports.map((r) => r.Id),
                    onSuccess,
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },

    removeFromProfile: {
        Id: 'RemoveFromProfile',
        Label: 'גריעת דוח מפרופיל',
        icon: 'clipboard-remove-outline',
        click: (reports, onSuccess) => {
            Dialog.confirm({
                message: 'האם ברצונך לגרוע דוחות אלה מהפרופיל?',
                confirmText: 'כן',
                cancelText: 'לא',
            })
                .then(({ result }) => {
                    if (result) {
                        const loading = Loading.open({
                            isFullPage: true,
                        });
                        ReportService
                            .removeFromProfile(reports.map((r) => r.Id))
                            .then(() => {
                                if (onSuccess) onSuccess();
                                Toast.open({
                                    type: 'is-success',
                                    message: 'הדוחות אושרו לתשלום!',
                                    duration: 4000
                                });
                            })
                            .catch((err) => {
                                let message = 'לא היה ניתן לבצע את הפעולה, נסה לאשר דוחות שוב.';
                                if (err.response?.data?.Message === 'Some or all reports were not excluded. Please note that reports must have alert of type "not mine".') message = 'חלק מהדוחות לא נגרעו. שים לב שניתן לגרוע רק דוחות עם התראה "לא שלי".';
                                Toast.open({
                                    type: 'is-danger',
                                    message,
                                    duration: 8000
                                });
                            })
                            .finally(() => {
                                loading.close();
                            });
                    }
                });
        },
    },

    reportsDetailsScanning: {
        Id: 'ReportsDetailsScanning',
        Label: 'סריקת נתוני דוחות',
        icon: 'flag-variant-outline',
        click: (reports) => {
            Dialog.confirm({
                message: 'האם אתה בטוח שברצונך להריץ סריקת נתונים לדוחות המסומנים?',
                onConfirm: () => {
                    reports.map((r) => r.ReportNumber)
                        .forEach(((i) => {
                            ReportService
                                .scanDetailsFromMunic({
                                    reportNumber: i,
                                });
                        }));
                    Toast.open({
                        type: 'is-success',
                        message: 'הסריקה החלה... התהליך עשוי להמשך מספר דקות. ניתן להמשיך בעבודה',
                        duration: 10000,
                    });
                },
                confirmText: 'בטוח!',
                cancelText: 'בטל',
            });
        },
    },
    reportsAlertsGenerator: {
        Id: 'ReportsAlertsGenerator',
        Label: 'סריקות התראות',
        icon: 'flag-variant-outline',
        click: (reports) => {
            Dialog.confirm({
                message: 'האם אתה בטוח שברצונך להריץ סריקת התראות לדוחות המסומנים?',
                onConfirm: () => {
                    reports.map((r) => r.ReportNumber)
                        .forEach(((i) => {
                            ReportService
                                .generateAlerts({
                                    reportNumber: i,
                                });
                        }));
                    Toast.open({
                        type: 'is-success',
                        message: 'הסריקה החלה... התהליך עשוי להמשך מספר דקות. ניתן להמשיך בעבודה',
                        duration: 10000,
                    });
                },
                confirmText: 'בטוח!',
                cancelText: 'בטל',
            });
        },
    },
    postRegisteredMail: {
        Id: 'PostRegisteredMail',
        Label: 'שליחה בדואר רשום',
        icon: 'email',
        click: (reports, onSuccess) => {
            Dialog.prompt({
                message: 'אנא הזינו את מספר אישור השליחה',
                confirmText: 'שלח',
                cancelText: 'סגור',
            })
                .then(({ result }) => {
                    if (result) {
                        const loading = Loading.open({
                            isFullPage: true,
                        });
                        LeasingCompaniesService
                            .setTransferStatus({
                                ReportIds: reports.map((r) => r.Id),
                                Reference: result,
                                TransferStatus: 'SentByMail',
                            })
                            .then((r) => {
                                // eslint-disable-next-line array-callback-return
                                const arrFails = r.data.filter((item) => { if (!item.Success) { return item.ReportNumber; } });
                                onSuccess(); // execute search again
                                if (arrFails.length > 0) {
                                    Dialog.alert(`<div style="max-height:300px">כל הדוחות נשמרו בהצלחה מלבד ${arrFails.map((currFail) => `<br/>${currFail.ReportNumber}`).join('')}</div>`);
                                } else {
                                    Toast.open({
                                        type: 'is-success',
                                        message: 'אישור שליחה נשמר בהצלחה!',
                                        duration: 4000,
                                    });
                                }
                            })
                            .catch(() => {
                                Toast.open({
                                    type: 'is-danger',
                                    message: 'לא היה ניתן לבצע את הפעולה, נסה שוב.',
                                    duration: 8000,
                                });
                            })
                            .finally(() => {
                                loading.close();
                            });
                    }
                });
        },
    },
    produceSingleReference: {
        Id: 'ProduceSingleReference',
        Label: 'הפק אסמכתה אחודה',
        icon: 'check',
        click: (reports, onSuccess) => {
            Dialog.confirm({
                message: 'האם אתה בטוח שברצונך להפיק אסמכתה אחודה לדוחות המסומנים?',
                onConfirm: () => {
                    const loading = Loading.open({
                        isFullPage: true,
                    });
                    ReportService
                        .produceJerusalemSingleReference(reports.map((r) => r.Id))
                        .then((r) => {
                            // eslint-disable-next-line array-callback-return
                            Dialog.confirm({
                                message: `
                                <div style="max-height:300px">
                                ${r.data.Reference ? `<div>מספר אסמכתה: ${r.data.Reference}</div>` : ''}
                                הופקו ${r.data.SuccessCount} מתוך ${r.data.TotalCount} דוחות
                                ${r.data.FailedReports && r.data.FailedReports.length ?
                                        `<div>
                                    דוחות שנכשלו:
                                    ${r.data.FailedReports.map((rep) => `<div>מספר דוח: ${rep.ReportNumber} מספר רכב: ${rep.PlateNumber} שגיאה: ${rep.Error}</div>`).join('')}
                                    </div>`
                                        :
                                        ''}
                                    ${r.data.GeneralError ? `<div>שגיאה נוספת: ${r.data.GeneralError}</div>` : ''}
                                </div>`,
                                onConfirm: () => onSuccess(),
                                confirmText: 'שמור',
                                canCancel: false
                            });
                            // Dialog.alert(`
                            //     <div style="max-height:300px">
                            //     ${r.data.Reference ? `<div>מספר אסמכתה: ${r.data.Reference}</div>` : ''}
                            //     הופקו ${r.data.SuccessCount} מתוך ${r.data.TotalCount} דוחות
                            //     ${r.data.FailedReports && r.data.FailedReports.length ?
                            //         `<div>
                            //         דוחות שנכשלו:
                            //         ${r.data.FailedReports.map((rep) => `<div>מספר דוח: ${rep.ReportNumber} מספר רכב: ${rep.PlateNumber} שגיאה: ${rep.Error}</div>`)}
                            //         </div>`
                            //         :
                            //         ''}
                            //         ${r.data.GeneralError ? `<div>שגיאה נוספת: ${r.data.GeneralError}</div>` : ''}
                            //     </div>`);
                        })
                        .catch((err) => {
                            Dialog.alert(`<div style="max-height:300px">${err.response?.data?.Message} </div>`);
                        })
                        .finally(() => {
                            loading.close();
                        });
                },
                confirmText: 'בטוח!',
                cancelText: 'בטל',
            });
        }
    },
    driverPostRegisteredMail: {
        Id: 'DriverPostRegisteredMail',
        Label: 'שליחה בדואר רשום',
        icon: 'email',
        click: (reports, onSuccess) => {
            Dialog.prompt({
                message: 'אנא הזינו את מספר אישור השליחה',
                confirmText: 'שלח',
                cancelText: 'סגור',
            })
                .then(({ result }) => {
                    if (result) {
                        const loading = Loading.open({
                            isFullPage: true,
                        });
                        DriverService
                            .setTransferStatus({
                                ReportIds: reports.map((r) => r.Id),
                                Reference: result,
                                TransferStatus: 'SentByMail',
                            })
                            .then((r) => {
                                // eslint-disable-next-line array-callback-return
                                const arrFails = r.data.filter((item) => { if (!item.Success) { return item.ReportNumber; } });
                                onSuccess(); // execute search again
                                if (arrFails.length > 0) {
                                    Dialog.alert(`<div style="max-height:300px">כל הדוחות נשמרו בהצלחה מלבד ${arrFails.map((currFail) => `<br/>${currFail.ReportNumber}`).join('')}</div>`);
                                } else {
                                    Toast.open({
                                        type: 'is-success',
                                        message: 'אישור שליחה נשמר בהצלחה!',
                                        duration: 4000,
                                    });
                                }
                            })
                            .catch(() => {
                                Toast.open({
                                    type: 'is-danger',
                                    message: 'לא היה ניתן לבצע את הפעולה, נסה שוב.',
                                    duration: 8000,
                                });
                            })
                            .finally(() => {
                                loading.close();
                            });
                    }
                });
        },
    },
    printTransfers: {
        Id: 'PrintTransfers',
        Label: 'הדפסה',
        icon: 'printer',
        click: (reports) => {
            Dialog.confirm({
                message: 'האם ברצונך להדפיס את הדוחות המסומנים?',
                confirmText: 'כן',
                cancelText: 'לא',
            })
                .then(({ result }) => {
                    if (result) {
                        const loading = Loading.open({
                            isFullPage: true,
                        });

                        LeasingCompaniesService
                            .printTransfers(reports.map((item) => item.Id))
                            .then((r) => {
                                printer.printHtml(r.data.Html, null, null, () => {
                                    Dialog.confirm({
                                        message: 'האם לסמן את הדוחות כנשלחו להדפסה?',
                                        confirmText: 'כן',
                                        cancelText: 'לא',
                                    })
                                        .then((toPrint) => {
                                            if (toPrint.result) {
                                                LeasingCompaniesService
                                                    .setTransferStatus({
                                                        TransferStatus: 'Printed',
                                                        ReportIds: reports.map((i) => i.Id),
                                                    }).then(() => {
                                                        Toast.open({
                                                            type: 'is-success',
                                                            message: 'סטטוס הדוחות שונה להודפסו!',
                                                            duration: 4000,
                                                        });
                                                    });
                                            }
                                        });
                                });
                            })
                            .catch(() => {
                                Toast.open({
                                    type: 'is-danger',
                                    message: 'לא היה ניתן לבצע את הפעולה, נסה שוב.',
                                    duration: 8000,
                                });
                            })
                            .finally(() => {
                                loading.close();
                            });
                    }
                });
        },
    },
    downloadFiles: {
        Id: 'downloadFiles',
        Label: 'הדפסת קבצי הסבה',
        icon: 'printer',
        click: (reports) => {
            Dialog.confirm({
                message: 'האם ברצונך להוריד את הדוחות המסומנים?',
                confirmText: 'כן',
                cancelText: 'לא',
            })
                .then(({ result }) => {
                    if (result) {
                        const loading = Loading.open({
                            isFullPage: true,
                        });

                        LeasingCompaniesService
                            .downloadTransfer(reports.map((item) => item.PdfUrl))
                            .then((r) => {
                                if (r.data) {
                                    const blob = new Blob([r.data], { type: 'application/pdf' });
                                    saveAs(blob, 'הסבה.pdf');
                                }
                            })
                            .catch(() => {
                                Toast.open({
                                    type: 'is-danger',
                                    message: 'לא היה ניתן לבצע את הפעולה, נסה שוב.',
                                    duration: 8000,
                                });
                            })
                            .finally(() => {
                                loading.close();
                            });
                    }
                });
        },
    },
    printDriverTransfers: {
        Id: 'PrintDriverTransfers',
        Label: 'הדפסה',
        icon: 'printer',
        click: (reports) => {
            Dialog.confirm({
                message: 'האם ברצונך להדפיס את הדוחות המסומנים?',
                confirmText: 'כן',
                cancelText: 'לא',
            })
                .then(({ result }) => {
                    if (result) {
                        const loading = Loading.open({
                            isFullPage: true,
                        });

                        DriverService
                            .printTransfers(reports.map((item) => item.Id))
                            .then((r) => {
                                printer.printHtml(r.data.Html, null, null, () => {
                                    Dialog.confirm({
                                        message: 'האם לסמן את הדוחות כנשלחו להדפסה?',
                                        confirmText: 'כן',
                                        cancelText: 'לא',
                                    })
                                        .then((toPrint) => {
                                            if (toPrint.result) {
                                                LeasingCompaniesService
                                                    .setTransferStatus({
                                                        TransferStatus: 'Printed',
                                                        ReportIds: reports.map((i) => i.Id),
                                                    }).then(() => {
                                                        Toast.open({
                                                            type: 'is-success',
                                                            message: 'סטטוס הדוחות שונה להודפסו!',
                                                            duration: 4000,
                                                        });
                                                    });
                                            }
                                        });
                                });
                            })
                            .catch(() => {
                                Toast.open({
                                    type: 'is-danger',
                                    message: 'לא היה ניתן לבצע את הפעולה, נסה שוב.',
                                    duration: 8000,
                                });
                            })
                            .finally(() => {
                                loading.close();
                            });
                    }
                });
        },
    },
    signOnReports: {
        Id: 'SignOnReports',
        Label: 'החתמת דוחות',
        icon: 'draw',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogSign,
                props: {
                    reports: reports.map((r) => r.Id),
                    onSuccess,
                    title: "חתימה על הסבות",
                    signCase: "leasingCompantLawyerSign"
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    signOnReportsDriver: {
        Id: 'SignOnReportsDriver',
        Label: 'החתמת דוחות',
        icon: 'draw',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogSign,
                props: {
                    reports: reports.map((r) => r.Id),
                    onSuccess,
                    title: "חתימה על הסבות",
                    signCase: "driverLawyerSign"
                },
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
    createTransfersCompany: {
        Id: 'CreateTransfersCompany',
        Label: 'הפקת מסמכי הסבה',
        icon: 'send',
        click: (reports) => {
            Dialog.confirm({
                message: 'האם אתה בטוח שברצונך להפיק מסמכי הסבה לדוחות המסומנים?',
                onConfirm: () => {
                    const loading = Loading.open();
                    LeasingCompaniesService
                        .transferReports(reports.map((r) => r.Id))
                        .then(() => {
                            Toast.open({
                                type: 'is-success',
                                message: 'הפעולה בוצעה!',
                                duration: 4000,
                            });
                        })
                        .catch(() => {
                            Toast.open({
                                type: 'is-danger',
                                message: 'לא היה ניתן לבצע את הפעולה!',
                                duration: 8000,
                            });
                        })
                        .finally(() => {
                            loading.close();
                        });
                },
                confirmText: 'בטוח!',
                cancelText: 'בטל',
            });
        },
    },
    createTransfersDriver: {
        Id: 'CreateTransfersDriver',
        Label: 'הפקת מסמכי הסבת עובד',
        icon: 'send',
        click: (reports) => {
            if (reports.some((r) => !r.Driver)) {
                Toast.open({
                    type: 'is-danger',
                    message: 'יש לשייך עובד לכל הדוחות המסומנים לפני הפקת מסמכי הסבה',
                    duration: 8000,
                });
                return;
            }
            Dialog.confirm({
                message: 'האם אתה בטוח שברצונך להפיק מסמכי הסבה לדוחות המסומנים?',
                onConfirm: () => {
                    const loading = Loading.open();
                    DriverService
                        .transferReportDriver(reports.map((r) => r.Id))
                        .then(() => {
                            Toast.open({
                                type: 'is-success',
                                message: 'הפעולה בוצעה!',
                                duration: 4000,
                            });
                        })
                        .catch(() => {
                            Toast.open({
                                type: 'is-danger',
                                message: 'לא היה ניתן לבצע את הפעולה!',
                                duration: 8000,
                            });
                        })
                        .finally(() => {
                            loading.close();
                        });
                },
                confirmText: 'בטוח!',
                cancelText: 'בטל',
            });
        },
    },
    tollRoadStatus: {
        Id: 'TollRoadStatus',
        Label: 'שינוי סטטוס',
        icon: 'credit-card-check',
        click: (reports, onSuccess) => {
            Modal.open({
                component: DialogTollRoadStatus,
                canCancel: false,
                hasModalCard: true,
                trapFocus: true,
                props: {
                    reports: reports.map((r) => r.Id),
                    onSuccess,
                },
            });
        },
    },
    requestDriverSignature: {
        Id: 'RequestDriverSignature',
        Label: 'בקשת חתימה מהעובד',
        icon: 'draw',
        click: (reports) => {
            Dialog.confirm({
                message: 'האם ברצונך לשלוח בקשת חתימה לעובד עבור הדוחות המסומנים?',
                confirmText: 'כן',
                cancelText: 'לא',
            })
                .then(({ result }) => {
                    if (result) {
                        const loading = Loading.open({
                            isFullPage: true,
                        });
                        Promise.all(reports.map((r) => AccidentService
                            .requestSignature(r.Id)))
                            .then(() => {
                                Toast.open({
                                    type: 'is-success',
                                    message: 'הבקשה נשלחה!',
                                    duration: 4000,
                                });
                            })
                            .catch(() => {
                                Toast.open({
                                    type: 'is-danger',
                                    message: 'לא היה ניתן לבצע את הפעולה, נסה לאשר דוחות שוב.',
                                    duration: 8000,
                                });
                            })
                            .finally(() => {
                                loading.close();
                            });
                    }
                });
        },
    },
    updateExcludedVehicles: {
        Id: 'updateExcludedVehicles',
        Label: 'עדכון רכבים לא מנוהלים',
        icon: 'flag-variant-outline',
        click: (vehicles) => {
            Dialog.confirm({
                message: 'האם אתה בטוח שברצונך לגרוע את הרכבים ממצבת הרכבים?',
                onConfirm: () => {
                    const loading = Loading.open();
                    const boolVar = vehicles.some(
                        (value) => typeof value === "object");
                    const vehivlesToSend = { PlateNumbers: boolVar ? vehicles.map((v) => v.PlateNumber) : vehicles };
                    VehicleService
                        .updateExcludedVehicles(vehivlesToSend)
                        .then(() => {
                            Toast.open({
                                type: 'is-success',
                                message: 'הפעולה בוצעה!',
                                duration: 4000,
                            });
                        })
                        .catch(() => {
                            Toast.open({
                                type: 'is-danger',
                                message: 'לא היה ניתן לבצע את הפעולה!',
                                duration: 8000,
                            });
                        })
                        .finally(() => {
                            loading.close();
                        });
                },
                confirmText: 'בטוח!',
                cancelText: 'בטל',
            });
        },
    },
    removeExcludedVehicles: {
        Id: 'removeExcludedVehicles',
        Label: 'ביטול גריעה',
        icon: 'undo',
        click: (vehicles, onSuccess) => {
            Dialog.confirm({
                message: 'האם אתה בטוח שברצונך לבצע ביטול גריעה לרכבים ?',
                onConfirm: () => {
                    const loading = Loading.open();
                    const boolVar = vehicles.some(
                        (value) => typeof value === "object");
                    const vehivlesToSend = { PlateNumbers: boolVar ? vehicles.map((v) => v.PlateNumber) : vehicles };
                    VehicleService
                        .removeExcludedVehicles(store.state.auth.profileId, vehivlesToSend)
                        .then(() => {
                            Toast.open({
                                type: 'is-success',
                                message: 'הפעולה בוצעה!',
                                duration: 4000,
                            });
                            onSuccess();
                        })
                        .catch(() => {
                            Toast.open({
                                type: 'is-danger',
                                message: 'לא היה ניתן לבצע את הפעולה!',
                                duration: 8000,
                            });
                        })
                        .finally(() => {
                            loading.close();
                        });
                },
                confirmText: 'בטוח!',
                cancelText: 'בטל',
            });
        },
    },
};

export default actions;
